import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { getKeyCodeForEvent, KeyCode } from '../../utils/key-code';
export var Target;
(function (Target) {
    Target["Self"] = "_self";
    Target["Blank"] = "_blank";
    Target["Parent"] = "_parent";
    Target["Top"] = "_top";
})(Target || (Target = {}));
/*
 * On iOS devices, the :active state of the anchor link is not displayed.
 * We can work around this by setting the link's onTouchStart to an empty handler.
 * TODO: In future we should handle the onTouchStart and onTouchEnd events in JS. #286517
 */
const iosTouchWorkaround = () => undefined;
/**
 * A simple wrapper for navigation links.
 * This ensures correct behaviour when the user selects something like 'open in new tab' from the context menu.
 */
export const Link = observer(props => {
    const { className, href, onClick, children, disabled, target, ariaLabel } = props;
    const b = bemClassBuilder('v-link');
    const handleClick = (event) => {
        if (disabled || !onClick) {
            return;
        }
        const isLeftClick = event.button === 0;
        const isClickWithModifierKey = event.metaKey || event.altKey || event.ctrlKey || event.shiftKey;
        if (!href || (isLeftClick && !isClickWithModifierKey)) {
            event.preventDefault(); // Prevent browser's default href navigation when using onClick handler
            onClick(event);
        }
    };
    const handleKeyDown = (event) => {
        if (disabled || !onClick) {
            return;
        }
        const keyCode = getKeyCodeForEvent(event);
        if (!(keyCode === KeyCode.Enter || keyCode === KeyCode.Space)) {
            return;
        }
        event.preventDefault(); // Prevent browser's default href navigation when using onClick handler
        if (!href) {
            onClick(event);
        }
    };
    if (!href) {
        return (_jsx("button", { className: b.block({ disabled }, className), onClick: handleClick, onKeyDown: handleKeyDown, onTouchStart: iosTouchWorkaround, tabIndex: disabled ? -1 : 0, "aria-label": ariaLabel, children: children }));
    }
    return (_jsx("a", { className: b.block({ disabled }, className), href: disabled ? undefined : href, onClick: handleClick, onKeyDown: handleKeyDown, onTouchStart: iosTouchWorkaround, target: target, rel: target === Target.Blank ? 'noopener noreferrer' : undefined, "aria-label": ariaLabel, children: children }));
});
Link.displayName = 'Link';
//# sourceMappingURL=link.js.map